import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import CertificateImg from '../assets/images/avndAngularDev.png';

const CertificatesItemStyles = styled.div`
  .certificateItem__img {
    width: 100%;
    height: 400px;
    border-radius: 12px;
    overflow: hidden;
    display: inline-block;
    border: 3px solid var(--gray-2);
    img {
      height: 100%;
    }
  }
  .certificateItem__info {
    margin-top: 1rem;
    background-color: var(--deep-dark);
    padding: 1rem;
    border-radius: 12px;
  }
  .certificateItem__title {
    font-size: 2.2rem;
  }
  .certificateItem__desc {
    font-size: 1.6rem;
    font-family: 'RobotoMono Regular';
    margin-top: 1rem;
  }
  .certificateItem__src {
    width: 50%;
    margin: auto;
    text-align: center;
    font-size: 1.6rem;
    font-family: 'RobotoMono Regular';
    padding: 1rem;
    margin-top: 2rem;
    border: 1px solid var(--gray-2);
    border-radius: 4px;
  }
  @media only screen and (max-width: 768px) {
    .certificateItem__img {
      height: 350px;
    }
  }
`;

export default function CertificatesItem({
  img = CertificateImg,
  title = 'Certificate Name',
  desc = 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
  source = 'https://www.dio.me/certificate/6A5081A4/',
}) {
  return (
    <CertificatesItemStyles>
      <Link to="/certificates" className="certificateItem__img">
        <img src={img} alt="certificate img" />
      </Link>
      <div className="certificateItem__info">
        <Link to="#">
          <h3 className="certificateItem__title">{title}</h3>
        </Link>
        <p className="certificateItem__desc">{desc}</p>
        <div className="certificateItem__src">
          <a href={source} target="_blank" rel="noreferrer">
            Ver Certificado
          </a>
        </div>
      </div>
    </CertificatesItemStyles>
  );
}
